import { API_URL } from '../../../../utils/config';

export const GET_FAILED_INSTALLATIONS_URL = `${API_URL}/getfailedinstallation`;
